import { ITodoItem } from 'views/dashboard/insight/todos/types';
import { apiV2 } from './axios';

export const getTodos = async (accountID: string): Promise<ITodoItem[]> => {
  const { data } = await apiV2.get<ITodoItem[]>('todos', {
    params: {
      accountID,
    },
  });
  return data;
};
